import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isStandalone || sessionStorage.getItem("eo_install_dismissed")) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setShow(false);
    setDeferred(null);
  };

  const dismiss = () => {
    sessionStorage.setItem("eo_install_dismissed", "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] w-[calc(100vw-2rem)] max-w-md bg-card border border-border shadow-xl px-4 py-3 flex items-center gap-3"
    >
      <div className="w-9 h-9 bg-primary text-primary-foreground flex items-center justify-center shrink-0">
        <Download className="w-4 h-4" strokeWidth={1.5} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium">Install Kora Holding Portfolio</p>
        <p className="text-xs text-muted-foreground">Add to your home screen for an app-like experience.</p>
      </div>
      <button
        onClick={install}
        data-testid="pwa-install-button"
        className="bg-primary text-primary-foreground text-sm px-3 py-1.5 shrink-0 hover:bg-primary/90 transition-colors"
      >
        Install
      </button>
      <button onClick={dismiss} data-testid="pwa-install-dismiss" className="text-muted-foreground hover:text-foreground shrink-0">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
